import { render, staticRenderFns } from "./CollegeSubscriptionVideos.vue?vue&type=template&id=3151ca46"
import script from "./CollegeSubscriptionVideos.vue?vue&type=script&lang=js"
export * from "./CollegeSubscriptionVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports